// Matches list filter params (`filter.<name>`), JSON:API filters (`filter[...]`), named
// queries (`query[...]`) and free-text search params so they never reach analytics vendors.
const SENSITIVE_PARAM = /^(filter|filters|query|search|keyword|q)(\.|\[|$)/;

export const isSensitiveParam = (key: string): boolean => SENSITIVE_PARAM.test(key);

const splitOnce = (value: string, separator: string): [string, string] => {
  const index = value.indexOf(separator);
  return index === -1 ? [value, ''] : [value.slice(0, index), value.slice(index + 1)];
};

export const scrubUrl = (url: string): string => {
  const [withoutHash, hash] = splitOnce(url, '#');
  const [path, query] = splitOnce(withoutHash, '?');
  if (!query) return url;

  const params = new URLSearchParams(query);
  Array.from(new Set(params.keys())).forEach(key => {
    if (isSensitiveParam(key)) params.delete(key);
  });

  const scrubbedQuery = params.toString();
  return `${path}${scrubbedQuery ? `?${scrubbedQuery}` : ''}${hash ? `#${hash}` : ''}`;
};
